module.exports = __webpack_public_path__ + "static/media/Benz_On_miller.9d16c21c.png";